import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import Countdown from 'react-countdown';
// import HtmlToReact, { Parser as HtmlToReactParser } from 'html-to-react';
// import moment from 'moment'

export default function WaitingScreenImage({ imgSrc, ...props }) {
  if(!imgSrc) {
    return <div className="alert alert-danger">No waiting screen image available.</div>
  }
  return (
    <div className="flave-video-container">
      <img src={imgSrc} className="waiting_screen_image" style={{width: "100%"}}/>
      {props.renderCustomContent != "false" && 
        <>
          {props.children}
        </>
      }
    </div>
  )
}

